import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom Hook to reset window scroll position on route changes.
 * This is the reactive alternative to the <ScrollToTop /> component.
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Professional standard: instant reset during virtual navigation
    });
  }, [pathname]);
};
